'use client';
import React, { useEffect, useState } from 'react';
import { usePipeline } from '@/contexts/PipelineContext';

export default function PipelineStatus() {
  const { status } = usePipeline();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status === 'loading') {
      setVisible(true);
    } else if (status === 'ready') {
      setVisible(true);
      const t = setTimeout(() => setVisible(false), 3000);
      return () => clearTimeout(t);
    } else if (status === 'error') {
      setVisible(true);
      const t = setTimeout(() => setVisible(false), 2000);
      return () => clearTimeout(t);
    } else {
      setVisible(false);
    }
  }, [status]);

  if (!visible || status === 'idle') return null;

  const dotStyle: React.CSSProperties = {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0,
  };

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span
          style={{
            ...dotStyle,
            backgroundColor: '#39ff6e',
            animation: 'pulse 1.2s ease-in-out infinite',
          }}
        />
        <span
          style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: 10,
            color: '#6b6b80',
            whiteSpace: 'nowrap',
          }}
        >
          Pre-loading...
        </span>
        <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }`}</style>
      </div>
    );
  }

  if (status === 'ready') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ ...dotStyle, backgroundColor: '#39ff6e' }} />
        <span
          style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: 10,
            color: '#39ff6e',
            whiteSpace: 'nowrap',
          }}
        >
          Research ready
        </span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ ...dotStyle, backgroundColor: '#ff3d3d' }} />
        <span
          style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: 10,
            color: '#6b6b80',
            whiteSpace: 'nowrap',
          }}
        >
          Will load on demand
        </span>
      </div>
    );
  }

  return null;
}
